import React from 'react';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp, {BLACK} from 'src/components/Stamp/Stamp';

interface Props {
  showTooltipFlag: boolean;
}

const LimitedScholarshipsText = (props: Props): React.ReactElement => {
  const {showTooltipFlag} = props;
  const infoText = 'Only available to select students';
  if (!showTooltipFlag) {
    return (
      <div className="college-earnings-no-earnings-status-text-content">
        <Stamp>{infoText}</Stamp>
      </div>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp color={BLACK} className="flag">
            <Icon iconType="flag" color="grey" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

export default LimitedScholarshipsText;
